export function SectionMeta({ num, label, right }) {
  return (
    <div className="section-meta reveal">
      <div className="mono num">{num}</div>
      <div className="section-meta-body">
        <div className="mono">{label}</div>
        {right && <div className="mono">{right}</div>}
      </div>
    </div>
  );
}
